import { useEffect } from 'react';
import { useAuth } from '../authentication/AuthContext';
import { initializeOrUpdatePaddle } from '../../lib/paddleClient';

const PaddleBootstrap = () => {
  const { user } = useAuth();
  const paddleCustomerId = user?.paddleUserId ?? user?.paddleCustomerId ?? null;

  useEffect(() => {
    let cancelled = false;

    initializeOrUpdatePaddle({ user })
      .catch((error) => {
        if (!cancelled) {
          console.error('Paddle initialization failed:', error);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [paddleCustomerId]);

  return null;
};

export default PaddleBootstrap;
